import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Row,
  Col,
  Dropdown,
  SelectPicker,
  Input,
  Button,
  DatePicker,
} from 'rsuite'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import {
  sessionGetItemObj,
  sessionGetItemStr,
  sessionRemoveItem,
  sessionSetItemStr,
} from '../../utils/sessionHelpers'
import { budgetFormat } from '../../utils/formatterUtil'
import { DATE_FORMAT, DATE_PICKER_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import moment from 'moment'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import '../../widgets/projectBasedItemsWidget/styles_table.less'

export default function CheckVoucherListTable({
  schema,
  loading,
  onSelect = () => {},
  onSearch = () => {},
  onCancel = () => {},
  onClick = () => {},
  disableForm,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [checkNumber, setCheckNumber] = useState('')
  const [checkDate, setCheckDate] = useState('')
  const [handleOnExport, setHandleOnExport] = useState()
  const [voucherNumber, setVoucherNumber] = useState('')
  const [voucherDate, setVoucherDate] = useState('')
  const [checkStatus, setCheckStatus] = useState('')

  useEffect(() => {
    setTableData(schema?.data?.values || [])
  }, [schema])

  const handleSearch = () => {
    // console.log('handleSearch ')
    var req = {
      checkNumber: checkNumber,
      checkDate: checkDate ? moment(checkDate).format(DATE_FORMAT) : '',
      voucherNumber: voucherNumber,
      voucherDate: voucherDate ? moment(voucherDate).format(DATE_FORMAT) : '',
      checkStatus: checkStatus,
    }

    onSearch(req)
  }

  const handleCancel = () => {
    setCheckNumber('')
    setCheckDate('')
    setVoucherNumber('')
    setVoucherDate('')
    setCheckStatus('')
    onCancel()
  }

  // console.log('tableData ', tableData)

  return (
    <>
      {schema.searchForm && (
        <Panel bordered header={'ค้นหา'} collapsible defaultExpanded>
          <div style={{ marginTop: -10, marginBottom: -10 }}>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.checkNumber.label}
                <Input
                  value={checkNumber}
                  onChange={(value) => {
                    setCheckNumber(value)
                  }}
                />
              </Col>

              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.checkDate.label}
                <DatePickerCustom
                  {...props}
                  placement="auto"
                  value={checkDate}
                  onChange={(value) => {
                    setCheckDate(value)
                  }}
                />
                {/* <DatePicker
                  format={DATE_PICKER_FORMAT}
                  locale={LOCAL_DAY_TH}
                  block
                  oneTap
                  placement="auto"
                  value={checkDate}
                  onChange={(value) => {
                    setCheckDate(value)
                  }}
                /> */}
              </Col>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.voucherNumber.label}
                <Input
                  value={voucherNumber}
                  onChange={(value) => {
                    setVoucherNumber(value)
                  }}
                />
              </Col>

              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.voucherDate.label}
                <DatePickerCustom
                  {...props}
                  placement="auto"
                  value={voucherDate}
                  onChange={(value) => {
                    setVoucherDate(value)
                  }}
                />
                {/* <DatePicker
                  format={DATE_PICKER_FORMAT}
                  locale={LOCAL_DAY_TH}
                  block
                  oneTap
                  placement="auto"
                  value={voucherDate}
                  onChange={(value) => {
                    setVoucherDate(value)
                  }}
                /> */}
              </Col>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.checkStatus.label}
                <SelectPicker
                  searchable={false}
                  value={checkStatus}
                  data={schema.searchForm.checkStatus.options}
                  block
                  onChange={(value) => {
                    setCheckStatus(value)
                  }}
                />
              </Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <SearchButton disabled={false} onClick={handleSearch}>
                  ค้นหา
                </SearchButton>
                {`  `}
                <CancelButton disabled={false} onClick={handleCancel}>
                  ยกเลิก
                </CancelButton>
              </Col>
            </Row>
          </div>
        </Panel>
      )}
      <Row style={{ marginTop: 10 }}>
        <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
          <IconButton
            appearance="ghost"
            icon={<Icon icon="file-pdf-o" className="bt-gost-icon-radius" />}
            // onClick={handleSubmit(handleOnExport)}
            onClick={(e) => {
              onClick(handleOnExport)
            }}
          >
            Export to PDF
          </IconButton>
        </Col>
      </Row>

      <div className="table-affix-header">
        <Table
          wordWrap
          // height={350}
          // autoHeight={tableData.length < 10}
          minHeight={350}
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: 10 }}
          affixHeader
        >
          <Column width={90} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={200}>
            <HeaderCell>เลขที่เช็ค</HeaderCell>
            <Cell dataKey="checkNumber" />
          </Column>
          <Column width={150}>
            <HeaderCell>วันที่ในเช็ค</HeaderCell>
            <Cell dataKey="checkDate" />
          </Column>

          <Column width={150}>
            <HeaderCell>เลขที่ใบสำคัญ</HeaderCell>
            <Cell dataKey="voucherNumber" />
          </Column>

          <Column width={150}>
            <HeaderCell>วันที่เอกสาร</HeaderCell>
            <Cell dataKey="voucherDate" />
          </Column>

          <Column width={280} minWidth={280} flexGrow={1}>
            <HeaderCell>จ่ายให้</HeaderCell>
            <Cell dataKey="expensesFor" />
          </Column>

          <Column width={180}>
            <HeaderCell>สถานะเช็ค</HeaderCell>
            <Cell dataKey="status" />
          </Column>

          <Column width={160}>
            <HeaderCell>วันที่เคลียริ่งเช็ค</HeaderCell>
            <Cell dataKey="checkClearingDate" />
          </Column>

          <Column width={200}>
            <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
            {/* <Cell style={{ textAlign: 'right' }} dataKey="amount" /> */}
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.amount)
              }}
            </Cell>
          </Column>

          <Column width={100} align="center" fixed="right">
            <HeaderCell>จัดการ</HeaderCell>
            <Cell>
              {(rowData) => {
                // console.log('file ', rowData)
                // disabled={!rowData.pathFile} เช็คกรณีที่ pathFile = null
                return (
                  <>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-df"
                        size="sm"
                        icon={<Icon icon="eye" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => {
                          onSelect(rowData, 'view')
                        }}
                      ></IconButton>
                      {!disableForm && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          size="sm"
                          icon={<Icon icon="edit" className="bt-gost-icon-none-radius-edit" />}
                          onClick={(e) => {
                            onSelect(rowData, 'edit')
                          }}
                        ></IconButton>
                      )}
                    </ButtonGroup>
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </div>
    </>
  )
}
